exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-id-column{width:160px}.buttons-column{width:80px;text-align:right}.buttons-column i{padding-left:8px}.date-column{width:260px;max-width:300px}.access-column{width:120px}.table-overflow{max-height:400px;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/main/webapp/app/entities/hebergement/droit/droit.css
// module id = 250
// module chunks = 0